import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DecryptFE, EncryptFE } from "../lib/encrypt";
import { login } from "../lib/api";

const SignInLayer = () => {

  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    // const token = localStorage.getItem('token');
    // const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    // if (token && user) {
    //   // If password is not auto-generated, redirect to dashboard
    //   if (!user.IsPasswordAutoGenerated) {
    //     navigate('/');
    //   } else {
    //     // If password is auto-generated, redirect to change password
    //     navigate('/change-password');
    //   }
    // }
  }, [navigate]);
  useEffect(() => {
// console.log(EncryptFE("abhinav@resolutesolutions.in"));
// console.log(DecryptFE("C3CHgQwSFOkGeuTRcvP3tW5qeSAD7PBDiNY9/0lXVNo="));
  },[])

  const handleInputChange = (field) => (event) => {
    const value = event.target.value;
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Clear errors when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
    if (errors.submit) {
      setErrors(prev => ({
        ...prev,
        submit: ''
      }));
    }
  };



const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setErrors({});

    console.log(formData.email);
    try {
      const encryptedEmail = EncryptFE(formData.email);
      const encryptedPassword = EncryptFE(formData.password);
      console.log(encryptedEmail);
      const response = await login(
        encryptedEmail, 
        encryptedPassword, 
        navigator.platform, 
        navigator.userAgent
      );
      
      // Store token and user data in localStorage
      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));
      
      // Check if password is auto-generated
      if (response.user.IsPasswordAutoGenerated) {
        // Redirect to change password page
        navigate('/change-password');
      } else {
        // Redirect to dashboard
        navigate('/');
      }

    } catch (error) {
      console.error('Login error:', error);
      
      let errorMessage = error.response?.data?.message || "An unexpected error occurred";
      
      setErrors({ submit: errorMessage });
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  // console.log(EncryptFE("admin3"));
  // console.log(EncryptFE("adminSurname1"));
  // console.log(EncryptFE("abhinav@resolutesolutions.in"));
  // console.log(EncryptFE("1234567890"));
  // console.log(EncryptFE("admin nagar"));
}, [])


  return (
    <section className='auth bg-base d-flex flex-wrap justify-content-center align-items-center'>

      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
        <div className='max-w-464-px mx-auto w-100'>
          <div>
 <Link to='/' className='mb-40 max-w-290-px d-block mx-auto text-center'>
  <img src='assets/images/SoksanLogo.png' alt='' className="mx-auto d-block" />
</Link>

            <h4 className='mb-12'>Sign In to your Account</h4>
            <p className='mb-32 text-secondary-light text-lg'>
              Welcome back! please enter your detail
            </p>
          </div>
          <form action='#' onSubmit={handleSubmit}>
            <div className='icon-field mb-16'>
              <span className='icon top-50 translate-middle-y'>
                <Icon icon='mage:email' />
              </span>
              <input
                type='email'
                className='form-control h-56-px bg-neutral-50 radius-12'
                placeholder='Email'
                id="email"
                value={formData.email}
                onChange={handleInputChange('email')}
                disabled={loading}
              />
            </div>
            <div className='position-relative mb-20'>
              <div className='icon-field'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  id='password'
                  placeholder='Password'
                  value={formData.password}
                  onChange={handleInputChange('password')}
                  disabled={loading}
                />
                {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
              </div>
              <span
              onClick={() => setShowPassword(!showPassword)}
                className='toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
                data-toggle='#your-password'
              />
            </div>
            <div className=''>
              <div className='d-flex justify-content-between gap-2'>
                <div className='form-check style-check d-flex align-items-center'>
                  <input
                    className='form-check-input border border-neutral-300'
                    type='checkbox'
                    defaultValue=''
                    id='remeber'
                  />
                  <label className='form-check-label' htmlFor='remeber'>
                    Remember me{" "}
                  </label>
                </div>
<Link 
  to='/forgot-password' 
  className='fw-medium' 
  style={{ color: "#FAA61A" }}
>
  Forgot Password?
</Link>

              </div>
            </div>
{errors.submit && (
  <div 
    className="mt-24 p-12 radius-8 d-flex align-items-center gap-2" 
    style={{ backgroundColor: "#fff1f0", border: "1px solid #ffa39e", color: "#cf1322" }}
  >
    <Icon icon="solar:danger-circle-bold" fontSize={20} />
    <span className="text-sm fw-medium">{errors.submit}</span>
  </div>
)}

<button
  type='submit'
  disabled={loading}
  className='btn text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
  style={{ backgroundColor: "#FAA61A", borderColor: "#FAA61A", color: "#fff" }}
>
  {loading ? "Signing In..." : "Sign In"}
</button>

          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
